var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row main-background"},[_c('b-col',{staticClass:"d-flex justify-content-center align-items-center"},[_c('b-spinner',{staticClass:"mr-2"}),_c('strong',[_vm._v("Loading...")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }